import { Box, Heading, Icon, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import useAuth from 'contexts/useAuth';
import { MdCode, MdLock, MdNotifications, MdPayment, MdPeople } from 'react-icons/md';
import { accountFeatures } from 'services/api.service';
import AccessTab from './settings/AccessTab';
import IntegrationsTab from './settings/IntegrationsTab';
import NotificationsTab from './settings/NotificationsTab';
import PaymentsTab from './settings/PaymentsTab';
import SecurityTab from './settings/SecurityTab';

export default function Settings() {
  const { userData } = useAuth();
  const { data } = useQuery(['features'], accountFeatures);

  return (
    <Box
      maxW="1200px"
      mx="auto"
    >
      <Box mb={6}>
        <Heading
          size="lg"
          mb={1}
        >
          Configurações
        </Heading>
        <Text color="gray.600">
          Olá, {userData?.name}. Gerencie suas preferências e segurança.
        </Text>
      </Box>

      <Tabs
        variant="enclosed"
        colorScheme="blue"
        isLazy
      >
        <TabList flexWrap="wrap">
          <Tab>
            <Icon
              as={MdLock}
              mr={2}
            />
            Segurança
          </Tab>
          <Tab>
            <Icon
              as={MdNotifications}
              mr={2}
            />
            Notificações
          </Tab>
          <Tab>
            <Icon
              as={MdPayment}
              mr={2}
            />
            Pagamentos
          </Tab>
          <Tab>
            <Icon
              as={MdCode}
              mr={2}
            />
            Integrações
          </Tab>
          <Tab>
            <Icon
              as={MdPeople}
              mr={2}
            />
            Acessos
          </Tab>
        </TabList>

        <TabPanels>
          <TabPanel px={0}>
            <SecurityTab
              masterPasswordEnabled={data?.masterPasswordEnabled}
              twoFaEnabled={data?.twoFaEnabled}
              loaded={!!data}
            />
          </TabPanel>

          <TabPanel px={0}>
            <NotificationsTab />
          </TabPanel>

          <TabPanel px={0}>
            <PaymentsTab />
          </TabPanel>

          <TabPanel px={0}>
            <IntegrationsTab />
          </TabPanel>

          <TabPanel px={0}>
            <AccessTab />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
}
